import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS, REQUEST, FAIL } from 'containers/App/configureStore';
import { fileAxios } from 'containers/App/screens/Foundation/utils';
import { url } from 'configs/';
const baseUrl = url.WEBBFF_API_SERVER;
const path = 'foundation/hire/';
const VALID_UPLOAD_HIRE_BASIC_FILE = `${path}VALID_UPLOAD_HIRE_BASIC_FILE`;
const DOWNLOAD_HIRE_IMPORT_EXAMPLE = `${path}DOWNLOAD_HIRE_IMPORT_EXAMPLE`;
const VERIFY_HIRE_UPLOAD_RESULT = `${path}VERIFY_HIRE_UPLOAD_RESULT`;
const IMPORT_HIRE_BASIC_FILE = `${path}IMPORT_HIRE_BASIC_FILE`;
const DELETE_STAGING_EXCEL = `${path}DELETE_STAGING_EXCEL`;
const GET_BATCH_HIRE_TEMP_WITH_ERROR = `${path}GET_BATCH_HIRE_TEMP_WITH_ERROR`;
const GET_BATCH_HIRE_TEMP = `${path}GET_BATCH_HIRE_TEMP`;

const initialState = {
  isGetHireTempLoading: false,
  isGetHireTempErrorLoading: false,
  isDeleteStagingExcel: false,
  isDownloading: false,
  upload: {
    isFetching: false,
    resultMessage: {},
  },
  import: {
    isFetching: false,
    resultMessage: {},
  },
};

export default typeToReducer({
  [GET_BATCH_HIRE_TEMP]: {
    [REQUEST]: (state) => Object.assign({}, state, { isGetHireTempLoading: true }),
    [FAIL]: (state) => Object.assign({}, state, { isGetHireTempLoading: false }),
    [SUCCESS]: (state) => Object.assign({}, state, { isGetHireTempLoading: false }),
  },
  [GET_BATCH_HIRE_TEMP_WITH_ERROR]: {
    [REQUEST]: (state) => Object.assign({}, state, { isGetHireTempErrorLoading: true }),
    [FAIL]: (state) => Object.assign({}, state, { isGetHireTempErrorLoading: false }),
    [SUCCESS]: (state) => Object.assign({}, state, { isGetHireTempErrorLoading: false }),
  },
  [DELETE_STAGING_EXCEL]: {
    [REQUEST]: (state) => Object.assign({}, state, { isDeleteStagingExcel: true }),
    [FAIL]: (state) => Object.assign({}, state, { isDeleteStagingExcel: false }),
    [SUCCESS]: (state) => Object.assign({}, state, { isDeleteStagingExcel: false }),
  },
  [DOWNLOAD_HIRE_IMPORT_EXAMPLE]: {
    [REQUEST]: (state) => Object.assign({}, state, { isDownloading: true }),
    [FAIL]: (state) => Object.assign({}, state, { isDownloading: false }),
    [SUCCESS]: (state) => Object.assign({}, state, { isDownloading: false }),
  },
  [VALID_UPLOAD_HIRE_BASIC_FILE]: {
    [REQUEST]: (state) => Object.assign({}, state, { upload: Object.assign({}, state.upload, { isFetching: true }) }),
    [FAIL]: (state) => Object.assign({}, state, { upload: Object.assign({}, state.upload, { isFetching: false }) }),
    [SUCCESS]: (state, action) => Object.assign({}, state, {
      upload: Object.assign({}, state.upload, { isFetching: false, resultMessage: action.payload.data }),
    }),
  },
  [VERIFY_HIRE_UPLOAD_RESULT]: {
    [REQUEST]: (state) => Object.assign({}, state, { upload: Object.assign({}, state.upload, { isFetching: true }) }),
    [FAIL]: (state) => Object.assign({}, state, { upload: Object.assign({}, state.upload, { isFetching: false }) }),
    [SUCCESS]: (state, action) => Object.assign({}, state, {
      upload: Object.assign({}, state.upload, { isFetching: false, resultMessage: action.payload.data }),
    }),
  },
  [IMPORT_HIRE_BASIC_FILE]: {
    [REQUEST]: (state) => Object.assign({}, state, { import: Object.assign({}, state.import, { isFetching: true }) }),
    [FAIL]: (state) => Object.assign({}, state, { import: Object.assign({}, state.import, { isFetching: false }) }),
    [SUCCESS]: (state, action) => Object.assign({}, state, {
      import: Object.assign({}, state.import, { isFetching: false, resultMessage: action.payload.data }),
    }),
  },
}, initialState);

/* 刪除暫存 */
export function deleteStagingExcel() {
  return {
    type: DELETE_STAGING_EXCEL,
    payload: axios.delete(`${baseUrl}Hire/BatchHire/DeleteStagingExcel`),
  };
}

/* 下載正確暫存資料 */
export function getBatchHireExcel() {
  return {
    type: GET_BATCH_HIRE_TEMP,
    payload: fileAxios.get(`${baseUrl}Hire/BatchHire/GetBatchHireTempExcel`),
  };
}

/* 下載錯誤資料 */
export function getBatchHireExcelWithError() {
  return {
    type: GET_BATCH_HIRE_TEMP_WITH_ERROR,
    payload: fileAxios.get(`${baseUrl}Hire/BatchHire/GetBatchHireExcelWithError`),
  };
}

/* 下載範本 */
export function downloadHireImportExample() {
  return {
    type: DOWNLOAD_HIRE_IMPORT_EXAMPLE,
    payload: fileAxios.get(`${baseUrl}Hire/BatchHire/GetBatchHireExcelSample`),
  };
}

/* 驗證上傳檔案 */
export function validUploadHireBasicFile(data) {
  return {
    type: VALID_UPLOAD_HIRE_BASIC_FILE,
    payload: axios.post(`${baseUrl}Hire/BatchHire/ExcelUpload`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  };
}

/* 確認匯入 */
export function importHireBasicFile(data) {
  return {
    type: IMPORT_HIRE_BASIC_FILE,
    payload: axios.post(`${baseUrl}Hire/BatchHire/ConfirmImport`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  };
}

/* 檢核暫存資料 */
export function verifyExcelResult() {
  return {
    type: VERIFY_HIRE_UPLOAD_RESULT,
    payload: axios.get(`${baseUrl}Hire/BatchHire/GetVerifyExcelResult`),
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Hire/reducers/uploadReducer.js
 **/